<template>
  <div>
    <div class="interest-free">
      <header></header>
      <section>
        <nd-button class="button"
                   @click="download"
        >下载{{ isIos === 'IOS' ? '天美贷' : '天美贷APP' }}立即借款
          <img
            class="hand"
            src="./newHumanity/img_shou@2x.png"
          />
        </nd-button>
        <div class="list-item">
          <div class="item">
            <img
              src="./images/icon_01.png"
              srcset="
                                    ./images/icon_01@2x.png 2x,
                                    ./images/icon_01@3x.png 3x
                                "
            />
            <div class="text-1">快速审批</div>
            <div class="text-2">最快5分钟放款</div>
          </div>
          <div class="item">
            <img
              src="./images/icon_02.png"
              srcset="
                                    ./images/icon_02@2x.png 2x,
                                    ./images/icon_02@3x.png 3x
                                "
            />
            <div class="text-1">分期偿还</div>
            <div class="text-2">可分12期偿还</div>
          </div>
          <div class="item">
            <img
              src="./images/icon_03.png"
              srcset="
                                    ./images/icon_03@2x.png 2x,
                                    ./images/icon_03@3x.png 3x
                                "
            />
            <div class="text-1">放心使用</div>
            <div class="text-2">正规持牌机构</div>
          </div>
        </div>
      </section>
      <div class="foot">
        <span>最长用12个月，综合年化利率15.4%起（单利计算）</span>
      </div>
    </div>
    <div class="cover" v-if='showImage'>
      <img class="wechat" src="./images/img_kuang@2x.png"/>
    </div>
    <ios-download v-model="downloadVisible"></ios-download>
  </div>
</template>

<script>
import { judgeClientSystem } from '@/assets/utils'
export default {
  name: 'wechat-scan-result',
  // customReadyNotify: true,
  data () {
    return {
      isIos: judgeClientSystem(),
      showImage: false
    }
  },
  created () {
    let value = navigator.userAgent
    // const isMobile = /(Android)/i.test(value)
    if (value.toLowerCase().includes('micromessenger')) {
      this.showImage = true
    } else {
      this.showImage = false
      this.downloadApp()
      // if (isMobile) {
      //   window.location = 'https://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/apk/release/tmd_Offical_release.apk'
      // }
    }
  },
  methods: {
    callAppBySchema (schema) {
      return new Promise((resolve, reject) => {
        let node = document.createElement('iframe')
        const body = document.body
        node.style.display = 'none'

        let clear = function (evt, isTimeout) {
          node.onload = null
          body.removeChild(node)
          node = null
        }

        node.onload = clear
        node.src = schema
        body.appendChild(node)
        let now = Date.now()

        setTimeout(() => {
          let newTime = Date.now()

          if (newTime - now > 1100) {
            resolve(true)
          } else {
            resolve(false)
          }
          clear()
        }, 1000)
      })
    },
    download () {
      this.downloadApp()
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.cover{
position:absolute;
top:0;
width: 750px;
height: 1449px;
padding-top:42px;
margin:auto;
background:#000000;
opacity: 0.75;
z-index:2;
.wechat{
    width: 620px;
    height:298px;
}
}
.interest-free {
    position: relative;
    z-index:1;
  header{
      background:url('./images/wechatScanResult.png') no-repeat;
      width:750px;
      height:1020px;
      background-size:cover;
  }
  section{
      width: 750px;
background: #FFFFFF;
border-radius: 40px 40px 0px 0px;
margin: -50px auto 34px;
overflow: hidden;
          .button {
            position: relative;
            width: 520px;
            height: 94px;
            line-height: 94px;
            margin: 50px auto 0;
            font-size: 36px;
            font-weight: 500;
            .hand {
                position: absolute;
                right: 13px;
                top: 50px;
                width: 100px;
                height: 110px;
                animation: hand 1s ease infinite;
            }
            @keyframes hand {
            0% {
                transform: translateY(-15px);
            }
            50% {
                transform: translateY(15px);
            }
            100% {
                transform: translateY(-15px);
            }
        }
        }
        .list-item {
            display: flex;
            justify-content: space-between;
            padding: 0 85px;
            margin-top: 68px;
            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                > img {
                    width: 90px;
                    height: 90px;
                }
                .text-1 {
                    margin-top: 18px;
                    font-size: 28px;
                    text-align: center;
                    color: #333333;
                    line-height: 40px;
                }
                .text-2 {
                    font-size: 24px;
                    text-align: center;
                    color: #999999;
                    line-height: 40px;
                }
            }
        }
  }
      .foot{
height: 66px;
line-height: 66px;
background: #FFEDE2;
text-align: center;
    span{
height: 33px;
font-size: 24px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #A07979;
line-height: 33px;
    }
  }
}
</style>
